import { render, staticRenderFns } from "./presentation-mode.vue?vue&type=template&id=2c479c6a&scoped=true&"
import script from "./presentation-mode.ts?vue&type=script&lang=ts&"
export * from "./presentation-mode.ts?vue&type=script&lang=ts&"
import style0 from "./presentation-mode.scss?vue&type=style&index=0&id=2c479c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c479c6a",
  null
  
)

export default component.exports